export const SET_SELECTED_LINK = "SET_SELECTED_LINK";
export const SET_SELECTED_PRIORITY = "SET_SELECTED_PRIORITY";
export const SET_PRIORITY_OPTIONS = "SET_PRIORITY_OPTIONS";
export const SET_TREATMENT_OPTIONS = "SET_TREATMENT_OPTIONS";
export const SET_STRUCTURE_OPTIONS = "SET_STRUCTURE_OPTIONS";